import { type CountryCode, getCountries } from 'libphonenumber-js'

const validCountries: Set<string> = new Set(getCountries())

export const isCountryCode = (value: string | number): value is CountryCode => {
  return typeof value === 'string' && validCountries.has(value)
}
